import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { LoginComponent } from './login.component';
import { routing } from './login.routing';
import { CoreModule } from '../../core/core.module';
import { IeeeLoginComponent } from './ieee-login/ieee-login.component';
import { LoginGuard } from './login.guard';
import { IopLoginComponent } from './iop-login/iop-login.component';
import { LibServLoginComponent } from './lib-serv-login/lib-serv-login.component';
import { WtcoxLoginComponent } from './wtcox-login/wtcox-login.component';
import { GenericLoginComponent } from './generic-login/generic-login.component';
import { SmaterialsLoginComponent } from './smaterials-login/smaterials-login.component';
import { SprotocolsLoginComponent } from './sprotocols-login/sprotocols-login.component';
import { SimageLoginComponent } from './simage-login/simage-login.component';
import { IopScienceLoginComponent } from './iop-science-login/iop-science-login.component';
import { IeeecsLoginComponent } from './ieeecs-login/ieeecs-login.component';

import { RscLoginComponent } from './rsc-login/rsc-login.component';
import { RcniLoginComponent } from './rcni-login/rcni-login.component';
import { HcnLoginComponent } from './hcn-login/hcn-login.component';
import { IjcLoginComponent } from './ijc-login/ijc-login.component';

import { TglLoginComponent } from './tgl-login/tgl-login.component';
import { NpgLoginComponent } from './npg-login/npg-login.component';
import { PalLoginComponent } from './pal-login/pal-login.component';
import { PalconnectLoginComponent } from './palconnect-login/palconnect-login.component';
import { AstmLoginComponent } from './astm-login/astm-login.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { SecurityCheckForgotpassComponent } from './security-check-forgotpass/security-check-forgotpass.component';
import { DemoLoginComponent } from './demo-login/demo-login.component';
import { HomeIndexComponent } from './home-index/home-index.component';
import { MmsLoginComponent } from './mms-login/mms-login.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        routing,
        CoreModule
    ],
    declarations: [
        //   LoginComponent,
        IeeeLoginComponent,
        IopLoginComponent,
        LibServLoginComponent,
        WtcoxLoginComponent,
        GenericLoginComponent,
        SmaterialsLoginComponent,
        SprotocolsLoginComponent,
        SimageLoginComponent,
        IopScienceLoginComponent,
        IeeecsLoginComponent,
        RscLoginComponent,
        RcniLoginComponent,
        HcnLoginComponent,
        IjcLoginComponent,
        TglLoginComponent,
        NpgLoginComponent,
        PalLoginComponent,
        PalconnectLoginComponent,
        AstmLoginComponent,
        ForgetPasswordComponent,
        SecurityCheckForgotpassComponent,
        DemoLoginComponent,
        HomeIndexComponent,
        MmsLoginComponent
    ],
    providers: [
        LoginGuard
    ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/pages/login/login.module.ts